<div class="title-container">
  @if (!isEditing) {
  <div class="title-display">
    <mat-icon
      id="alerts-expand-panel-view"
      class="material-symbols-outlined caret-toggle"
      (click)="togglePanel($event)"
      (keydown.enter)="togglePanel($event)"
      (keydown.space)="togglePanel($event)"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="isPanelOpen"
      aria-label="Toggle alert details"
      aria-hidden="false"
    >
      {{ isPanelOpen ? 'expand_less' : 'expand_more' }}
    </mat-icon>
    <span class="title-text">{{ title }}</span>
    @if (isSystemGenerated) {
    <span class="system-generated-badge"> SYSTEM </span>
    } @if (!isSystemGenerated) {
    <mat-icon id="edit-alert-title-icon" class="edit-icon" (click)="startEdit()"
      >edit
    </mat-icon>
    }
  </div>
  } @if (isEditing) {
  <div class="title-edit">
    <div class="input-wrapper">
      <div class="input-container">
        <input
          #titleInput
          type="text"
          maxLength="100"
          [(ngModel)]="title"
          (keyup)="saveEdit($event)"
          (blur)="cancelEdit()"
          (input)="handleInput($event)"
          [matTooltip]="tooltipMessage"
          matTooltipPosition="right"
          [matTooltipDisabled]="true"
          matTooltipClass="error-tooltip"
          #tooltip="matTooltip"
        />
        @if (isError) {
        <mat-icon class="error-icon">error</mat-icon>
        }
      </div>
      <div class="action-buttons-container">
        @if (title.trim().length !== 0) {
        <mat-icon class="check-icon" (mousedown)="saveEdit($event)"
          >check</mat-icon
        >
        <mat-divider [vertical]="true"></mat-divider>
        }
        <ng-container>
          <mat-icon class="close-icon" (mousedown)="cancelEdit()"
            >close</mat-icon
          >
        </ng-container>
      </div>
    </div>
  </div>
  }
</div>
